exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.section[data-v-d0417bc4] {\n  padding-top: 120px;\n  overflow-x: hidden;\n}\n@media all and (max-width: 768px) {\n.section[data-v-d0417bc4] {\n    padding-top: 80px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-d0417bc4","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/source/Section.vue
// module id = 376
// module chunks = 0